import { motion } from "framer-motion";
import { Target, Eye } from "lucide-react";

export const MissionVision = () => {
  return (
    <section
      id="mission"
      data-testid="mission-vision-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16">
          <div className="text-xs tracking-[0.3em] uppercase text-[#1D4E89] font-medium mb-5">
            What we stand for
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-[#0B2B40] tracking-tight leading-tight font-light">
            Our mission &{" "}
            <span className="italic">our vision.</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="bg-[#F8F9FA] p-10 md:p-12 border-l-2 border-[#1D4E89]"
            data-testid="mission-card"
          >
            <Target size={28} className="text-[#1D4E89]" />
            <div className="mt-5 text-xs tracking-[0.25em] uppercase text-[#1D4E89] font-medium">
              Our Mission
            </div>
            <h3 className="font-serif text-3xl text-[#0B2B40] mt-3 leading-snug">
              Empower people to rise from within.
            </h3>
            <p className="mt-6 text-[#4A5568] leading-relaxed">
              At RB InnerRise Coaching Academy, our mission is to empower
              individuals and communities through life coaching, education,
              wellness, leadership, meditation, breathing practices, and
              personal development.
            </p>
            <p className="mt-4 text-[#4A5568] leading-relaxed">
              We are committed to helping people build confidence, discover
              purpose, strengthen communication, improve well-being, and create
              meaningful and successful lives.
            </p>
            <p className="mt-6 font-serif italic text-[#0B2B40] text-lg">
              “Keep learning, keep growing, keep dreaming.”
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="bg-[#0B2B40] text-white p-10 md:p-12 border-l-2 border-[#E8F0F8]"
            data-testid="vision-card"
          >
            <Eye size={28} className="text-[#E8F0F8]" />
            <div className="mt-5 text-xs tracking-[0.25em] uppercase text-[#E8F0F8] font-medium">
              Our Vision
            </div>
            <h3 className="font-serif text-3xl mt-3 leading-snug">
              A global academy that transforms lives.
            </h3>
            <p className="mt-6 text-white/80 leading-relaxed">
              Our vision is to become a trusted global coaching and wellness
              academy that transforms lives through education, inspiration,
              leadership, and human connection.
            </p>
            <p className="mt-4 text-white/80 leading-relaxed">
              We envision a world where individuals from all backgrounds have
              the confidence, knowledge, wellness, and support needed to
              achieve their dreams and positively impact their communities.
            </p>
            <p className="mt-6 font-serif italic text-white text-lg">
              Growth · Compassion · Leadership · Mindfulness · Lifelong learning.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
